"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeedback = getFeedback;

var _request = _interopRequireDefault(require("@/utils/request"));

function getFeedback(id) {
  return (0, _request.default)({
    url: "/feedback/".concat(id),
    method: 'get'
  });
}